import React, { useState, useEffect } from 'react';
import ProcedureListMobile from './procedureListMobile';
import ProcedureListWeb from './procedureListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const ProcedureListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? (
    <ProcedureListMobile {...props} />
  ) : (
    <ProcedureListWeb {...props} />
  );
};

export default ProcedureListRouter;
